import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Callout from 'components/misc/Callout';
import _get from 'lodash/get';
import { LocalizedMessage, standardDateNoSecondsOptions } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import { ContainedButton } from 'components/core/Button';
import Card from 'components/core/Card';
import DateTimePicker2 from 'components/core/DateTimePicker2/DateTimePicker2';
// HOCS
import withFormManagement from 'hocs/WithFormManagement';
// Utils
import { completeFormErrors } from 'utils/Forms';
import {
  dateGenerator,
  dateFormatter,
  timezoneUtils,
  dateQuery,
} from 'utils/DateUtils';
import RegexUtils from 'utils/RegexUtils';

const CheckoutTemporaryExitEnd = ({
  fields: { end },
  errors,
  onDemandTemporaryExitMaxDuration,
  onFieldsChange,
  onValidate,
  onErrorsChange,
}) => {
  const { formatMessage: t } = useIntl();

  // Handlers
  const handleValidate = () => {
    let clientErrors;
    if (!end) {
      clientErrors = completeFormErrors(errors, 'end', ['cantBeBlank']);
    }

    const endBeforeNow = end && dateQuery.isBefore(dateGenerator.date(end), dateGenerator.date(dateGenerator.now()));
    if (endBeforeNow) {
      clientErrors = completeFormErrors(errors, 'end', ['endBeforeNow']);
    }

    if (clientErrors) {
      onErrorsChange(clientErrors);
      return;
    }

    onValidate({
      estimatedEnd: dateFormatter.toServerFormat(end, timezoneUtils.userTimezone()),
    });
  };

  /* Max temporary indication */
  /* ------------------------ */
  const maxDurationDays = Math.floor(onDemandTemporaryExitMaxDuration / 1440);
  const maxDurationHours = Math.floor((onDemandTemporaryExitMaxDuration - (maxDurationDays * 1440)) / 60);
  const maxDurationMinutes = onDemandTemporaryExitMaxDuration - (maxDurationHours * 60) - (maxDurationDays * 1440);

  const BannerMaxDuration = onDemandTemporaryExitMaxDuration ? (
    <Callout withInfoIcon severity="warning">
      {t({
        id:
        /* eslint-disable */
        (maxDurationDays && maxDurationHours && maxDurationMinutes) ? 'info.onDemandTemporaryMaxDurationWarningDaysHoursMinutes' :
        (maxDurationDays && maxDurationHours)                       ? 'info.onDemandTemporaryMaxDurationWarningDaysHours' :
        (maxDurationDays && maxDurationMinutes)                     ? 'info.onDemandTemporaryMaxDurationWarningDaysMinutes' :
        (maxDurationHours && maxDurationMinutes)                    ? 'info.onDemandTemporaryMaxDurationWarningHoursMinutes' :
        (maxDurationDays)                                           ? 'info.onDemandTemporaryMaxDurationWarningDays' :
        (maxDurationHours)                                          ? 'info.onDemandTemporaryMaxDurationWarningHours' :
        (maxDurationMinutes)                                        ? 'info.onDemandTemporaryMaxDurationWarningMinutes' : ''
        /* eslint-enable */
      }, {
        days: maxDurationDays,
        hours: maxDurationHours,
        minutes: maxDurationMinutes,
      })}
    </Callout>

  ) : null;

  /* End */
  /* --- */
  const now = new Date();
  const minDate = now;
  const maxDate = onDemandTemporaryExitMaxDuration ? new Date(minDate) : null;
  if (maxDate) {
    maxDate.setMinutes(maxDate.getMinutes() + onDemandTemporaryExitMaxDuration);
  }

  const End = (
    <DateTimePicker2
      name="end"
      calendarType="end"
      minDate={minDate}
      {...(maxDate ? { maxDate } : {})}
      date={end}
      labelDateId="label.date"
      placeholderId="placeholder.end"
      calendarLabelId="calendarLabel.end"
      errorText={_get(errors, 'end') || _get(errors, 'estimatedEnd')}
      onChange={(newEnd) => onFieldsChange({ end: newEnd })}
    />
  );

  return (
    <Card>
      <div className="d-flex flex-column text-center" style={{ gap: 30 }}>
        <LocalizedMessage className="checkoutCardTitle" id="info.checkoutTemporaryExitEnd.title" />
        <LocalizedMessage className="checkoutCardSubtitle" id="info.checkoutTemporaryExitEnd.subtitle" />
        {BannerMaxDuration}
        <div className="my-3 mx-auto" style={{ width: 'fit-content' }}>
          {End}
        </div>
        <LocalizedMessage className="checkoutCardBody" id="info.checkoutTemporaryExitEnd.body" />
        <ContainedButton label={<LocalizedMessage id="button.validate" />} onClick={handleValidate} />
      </div>
    </Card>
  );
};

CheckoutTemporaryExitEnd.propTypes = {
  fields: PropTypes.object.isRequired,
  onDemandTemporaryExitMaxDuration: PropTypes.number.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
};

CheckoutTemporaryExitEnd.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  end: {
    defaultValue: null,
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  operationError: {
    ...ownProps.cpmOnDemandSelfCheckoutError,
    messageValuesExtractors: {
      estimatedEnd: [
        {
          key: 'date',
          pattern: RegexUtils.dateTime,
          setTransform: (value, locOwnProps) => locOwnProps.intl.formatDate(value, standardDateNoSecondsOptions),
        },
      ],
    },
  },
});

const mapStateToProps = (state) => ({
  cpmOnDemandSelfCheckoutError: _get(state, 'cpmOnDemand.checkout.error', null),
  onDemandTemporaryExitMaxDuration: _get(state, 'cpmOnDemand.result.carpark.onDemandTemporaryExitMaxDuration', null),
});

module.exports = compose(
  connect(mapStateToProps),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
)(CheckoutTemporaryExitEnd);



// WEBPACK FOOTER //
// ./routes/checkout/components/CheckoutTemporaryExitEnd.js